import Vue from 'vue';
import appFilter from "../../../components/base/app-filter/app-filter";
import vacancy from "../../../components/base/vacancies/vacancies";
import partners from "../../../components/base/vacancies/partners";
import useVacancies from '../../domain/use-vacancies';
import vacanciesListService from '../../domain/services/vacancies-list-service';
import IconReload from '../../../components/icons/icon-reload'
import PreloaderNew from '../../../components/preloader/preloader-new'

export default Vue.component('vacanciesList', {
  components: {
    appFilter,
    vacancy,
    partners,
    IconReload,
    PreloaderNew
  },
  data() {
    return {
      title: 'vacanciesList',
      selectSortedVacancies: '-created_at' ,
      selectedPartners: '-1',
      optionsVacancies: [
        { label: 'Показать сначала новые вакансии', value: '-created_at' },
        { label: 'Показать сначала старые вакансии', value: 'created_at'},
      ],
      optionsPartners: [],
      loading: false,
      partnersList: [],
      sponsors: [],
      partnerId: '',
      vacanciesMeta: null,
      vacanciesList: [],
      vacanciesParams: {
        sort: '-created_at',
        page: 1,
        'per-page': 4,
        is_active: 1
      }
    }
  },
  computed: {
    showMoreBtn() {
      if (
        this.vacanciesList &&
        this.vacanciesList.length &&
        this.vacanciesMeta.currentPage < this.vacanciesMeta.pageCount
      ) {
        return true
      }
      return false
    }
  },

  async created() {
    this.vacanciesParams = vacanciesListService.getParamsFromUrl()
    await this.getVacanciesList(this.vacanciesParams)
    await this.getPartnersList()
  },

  watch: {
    async selectSortedVacancies() {
      this.vacanciesParams.sort = this.selectSortedVacancies
      await this.changeSort(this.vacanciesParams)
    },
    async selectedPartners() {
      this.vacanciesParams.sponsor_ids = this.selectedPartners
      this.vacanciesParams = vacanciesListService.getFilteredParams(this.vacanciesParams)
      vacanciesListService.updateURL(this.vacanciesParams)
      await this.getVacanciesList(this.vacanciesParams)
    }
  },

  methods: {
    async getVacanciesList(params) {
      try {
        this.loading = true
        const {data, meta} = await useVacancies().getVacanciesList(params)
        this.vacanciesList = data
        this.vacanciesMeta = meta
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async getPartnersList() {
      try {
        this.loading = true
        const params = {
          hasVacancies: 1
        }
        const res = await useVacancies().getMyVacancies(params)
        this.partnersList = vacanciesListService.getAllPartners(res)
        this.optionsPartners = vacanciesListService.getOptionPartners(this.partnersList)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async changeSort() {
      this.vacanciesParams.page = 1
      vacanciesListService.updateURL(this.vacanciesParams)
      await this.getVacanciesList(this.vacanciesParams)
    },

    async changeFilter(ids) {
      this.vacanciesParams.page = 1
      this.vacanciesParams.sponsor_ids = ids
      this.vacanciesParams = vacanciesListService.getFilteredParams(this.vacanciesParams)
      vacanciesListService.updateURL(this.vacanciesParams)
      await this.getVacanciesList(this.vacanciesParams)
    },

    async addMoreVacancies() {
      const { data, meta } = await useVacancies().getVacanciesList(this.vacanciesParams)
      this.vacanciesList = [...this.vacanciesList, ...data ]
      this.vacanciesMeta = meta
    },

    async showMore() {
      this.vacanciesParams.page++
      await this.addMoreVacancies()
    },
  }
});
